import { Route, Routes } from 'react-router'
import { RequireAuth } from './auth/RequireAuth'
import { Layout } from './components/Layout'
import { SiteFooter } from './components/SiteFooter'
import { AcceptInviteScreen } from './screens/AcceptInviteScreen'
import { AccountDetailScreen } from './screens/AccountDetailScreen'
import { AccountScreen } from './screens/AccountScreen'
import { AdminScreen } from './screens/AdminScreen'
import { AppScreen } from './screens/AppScreen'
import { ChartsScreen } from './screens/ChartsScreen'
import { CrashGroupScreen } from './screens/CrashGroupScreen'
import { CrashReportScreen } from './screens/CrashReportScreen'
import { CrashSymbolsScreen } from './screens/CrashSymbolsScreen'
import { CompareScreen } from './screens/CompareScreen'
import { LoginScreen } from './screens/LoginScreen'
import { MoversScreen } from './screens/MoversScreen'
import { NotFoundScreen } from './screens/NotFoundScreen'
import { ResetPasswordScreen } from './screens/ResetPasswordScreen'
import { SearchScreen } from './screens/SearchScreen'
import { StatusScreen } from './screens/StatusScreen'
import { StoreKeeperResetScreen } from './screens/StoreKeeperResetScreen'
import { SupportThreadScreen } from './screens/SupportThreadScreen'

export function App() {
	return (
		<>
			<Routes>
				<Route path="/login" element={<LoginScreen />} />
				<Route path="/invite/:token" element={<AcceptInviteScreen />} />
				<Route path="/reset/:token" element={<ResetPasswordScreen />} />
				<Route path="/account-reset" element={<StoreKeeperResetScreen />} />
				<Route
					element={
						<RequireAuth>
							<Layout />
						</RequireAuth>
					}
				>
					<Route index element={<ChartsScreen />} />
					<Route path="apps/:id" element={<AppScreen />} />
					<Route path="search" element={<SearchScreen />} />
					<Route path="movers" element={<MoversScreen />} />
					<Route path="compare" element={<CompareScreen />} />
					<Route path="status" element={<StatusScreen />} />
					<Route path="account" element={<AccountScreen />} />
					<Route
						path="admin"
						element={
							<RequireAuth admin>
								<AdminScreen />
							</RequireAuth>
						}
					/>
					<Route
						path="admin/accounts/:id"
						element={
							<RequireAuth admin>
								<AccountDetailScreen />
							</RequireAuth>
						}
					/>
					<Route
						path="admin/crashes/symbols"
						element={
							<RequireAuth admin>
								<CrashSymbolsScreen />
							</RequireAuth>
						}
					/>
					<Route
						path="admin/crashes/group/:signature"
						element={
							<RequireAuth admin>
								<CrashGroupScreen />
							</RequireAuth>
						}
					/>
					<Route
						path="admin/crashes/:id"
						element={
							<RequireAuth admin>
								<CrashReportScreen />
							</RequireAuth>
						}
					/>
					<Route
						path="admin/support/:id"
						element={
							<RequireAuth admin>
								<SupportThreadScreen />
							</RequireAuth>
						}
					/>
					<Route path="*" element={<NotFoundScreen />} />
				</Route>
			</Routes>
			<SiteFooter />
		</>
	)
}
